<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleUpdate"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class EditAdminUser extends Vue {

  @Prop(Array) tags;

  data = {}

  get columns() {
    return createColumns.call(this);
  }

  async mounted() {
    this.data = await this.$request.get(`/admin_users/${this.$route.params.id}`);
  }

  async handleUpdate(data) {
    const id = this.data.id;
    await this.$request.put(`/admin_users/${id}`, data);
    this.$router.replace({ name: 'admin_users.show', params: { id } });
  }
}
</script>
